
import React, { useEffect, useRef, useState, Fragment, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect'
import moment from 'moment';
import { useIntl } from 'react-intl'
import _ from 'lodash';

//Controls
import OdometerView, { getOdometerValue } from 'Modules/.common/components/OdometerView';
import SidePanel, { SidePanelHeader, SidePanelBody } from 'Components/SidePanel';
import { Grid, Paper, Container, Typography, Icon } from '@mui/material';
import { SearchInput, Toolbar, Button } from 'Components/uiControls';
import { IconButton, Modal, Tooltip } from '@gpstrackit/gtc-react-controls';
import { NotificationManager } from 'Components/Notifications';
import TagsManage from 'Modules/.common/components/TagsManage';
import { OemDataButton } from 'Modules/.common/components/OemDataModal';
import { Timezone } from '../../../../components/uiControls';
import { TableButtons } from 'Components/uiControls/Table';
import { PillsGroup } from "@gpstrackit/gtc-react-controls";
import { MenuComponent } from 'Components/Menu';
import { TagsGroup } from 'Components/Tag';
import Select from 'Components/Select';
import Pill from 'Components/Pill';
import ModalExportColumnsPdf from '../../components/modalExportColumnsPdf';

//Icons
import RoomIcon from '@mui/icons-material/Room';
import FlagIcon from '@mui/icons-material/Flag';
import NavigationIcon from '@mui/icons-material/Navigation';

//Views
import ByVehicles from './.components/byVehicles'
import ByVehicleGroups from './.components/byVehicleGroups'
import ModalEnableDisable from 'Modules/fleet/components/ModalEnableDisable';
import ModalOutputs from 'Modules/fleet/components/ModalOutputs';
import FleetModalBulkOutputs from 'Modules/fleet/components/ModalBulkOutputs';
import ModalPing from 'Modules/fleet/components/ModalPing';
import ModalScheduleStarter from 'Modules/fleet/components/ModalScheduleStarter';
import ModalLandMark from "Modules/fleet/components/ModalLandMark";
import EditUnitSettings from 'Modules/settings/views/unitSettings/components/editUnitSettings';
import EditMultipleUnits from 'Modules/settings/views/unitSettings/components/editMultipleUnits';
import ModalTroubleshootDevice from 'Modules/.common/components/TroubleshootDevice';
import ModalWarnings from 'Modules/.common/components/Warnings';
import CameraSetup from 'Modules/.common/components/CameraSetup';
import MapModal from 'Modules/.common/components/MapModal';
import ModalUpdateUnit from '../../components/ModalUpdateUnit';
import ModalImportUnits from '../../components/ModalImportUnits';
import ImportResultsModal from '../../../../core/views/importResultsModal';
import { enrichUnitsWithAssets } from '../../../../core/catalogs/redux/sliceRealtime';
import { enrichUnitsWithDrivers } from '../../../../core/catalogs/redux/sliceRealtime';

import { GetEventTemperatureValue, GetEventName } from 'Modules/.common/components/EventViewTools'

//Helpers
import {
    formatOffsetDisplayOdometer, formatOffsetDisplayEngineHours, copyToClipboard, getFormattedField,
    getFormattedDateByTimeZone, GetFormatForMoment, getUnitsNaturalOrder,
    convertToKPH, converSpeedToMph
} from '../../../../core/data/Helpers';
import { getAbbvTimezone } from "Components/uiControls/Timezone/tools";
import { ExceptionManager, LogManagerConsole } from 'Core/logManager';
import Preferences from 'Core/containers/Preferences';
import { getIconLandmark } from 'Components/Map/utils';
import { getWarningCategory } from 'Core/hooks/utils';
import { checkDeviceData } from 'Core/data/Helpers';
import { getTagColor } from 'Core/data/Helpers';
import { HasPermission } from 'Core/security';

// Hooks / Utils
import RowMemoizer from 'Core/data/RowMemoizer';
import { useDataGridThrottler, useDataGridThrottlerWithTrackedIds, useRealtimeTags } from 'Core/hooks';
import { useImportNotifications } from 'Core/hooks/useImportNotifications';

//Slice
import { openModalExportColumnPdf } from '../../components/modalExportColumnsPdf/redux/slice';
import { openImportUnitsModal } from '../../components/ModalImportUnits/redux/slice';
import { setImportNotification } from 'Modules/fleet/components/ModalImportUnits/redux/slice';

// Real-Time Selectors mapped to dictionaries
import { unitSelectors } from 'Core/realtime/redux/unitSlice';
import { lastReadingSelectors } from 'Core/realtime/redux/lastReadingSlice';
import { driverSelectors } from 'Core/realtime/redux/driverSlice';
import { assetSelectors } from 'Core/realtime/redux/assetSlice';

//Actions
import {
    modalPingOpen,
    fleetOpenModalStarterSchedule,
    fleetMainChangeFilters,
    openFleetLandmarkModal,
    modalEnableStarterOpen,
    fleetModalOutputsOpen,
    fleetModalBulkOutputsOpen,
    unitEditUnitOpen,
    editMultipleUnits,
    catalogLoad,
    getLandmarksAndGeofences as getKmls,
    openOverViewUnit,
    openWarningsModal,
    openModalCameraSetup,
    openModalFleetUpdateUnit
} from 'Redux/actions';

//Styles
import styles from 'Assets/sass/core/vars.scss';
import './style.scss';
import EventReports, { getEventColor } from "Modules/reports/views/main/components/reportsTab/.components/eventReport";
import { translateEvent, mapInputEventName } from '../../../.common/utils/translateEvents';
import { getSearchPlaceholder, getEventSearchValue, getVinSearchValue, getLinkedDeviceSearchValue } from './utils';

var moduleUnitSettings = false;
const Main = (props) => {
    moduleUnitSettings = props.moduleUnitSettings;
    const tableRef = useRef();
    const preferencesRef = useRef();
    const bottomRef = useRef(null);

    const dispatch = useDispatch()
    const { messages, locale } = useIntl()

    const [isGrouping, setIsGrouping] = useState(false)
    const [hasFilters, setHasFilters] = useState(false)
    const [searchText, setSearchText] = useState('')
    const [formatSearchText, setFormatSearchText] = useState('')
    const [selectedItems, setSelectedItems] = useState([])
    const [columns, setColumns] = useState([]);
    const [sortColumns, setSortColumns] = useState([]);
    const [sort, setSort] = useState();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [preferences, setPreferences] = useState({});

    const loadingReadings = useSelector(state => state.catalogsRedux.loadingReadings)
    const loadingVehicleStatus = useSelector(state => state.catalogsRedux.loadingVehicleStatus)
    const loadingUnitsList = useSelector(state => state.catalogsRedux.loadingUnitsList)
    const user = useSelector(state => state.securityRedux.user);
    const lang = useSelector(state => state.commomRedux.language);
    const filters = useSelector(state => state.fleetMainRedux.filters);
    const loadingLandmarkJson = useSelector((state) => state.catalogsRealtimeRedux.loadingLandmarks);
    const tags = useRealtimeTags({ trackFields: ['id', 'label', 'disabled', 'tagPath', 'tags'] });
    const openModalTroubleshootDevice = useSelector(state => state.troubleshootDeviceRedux.open);
    const openModalWarnings = useSelector(state => state.warningsRedux.open);
    const openMCameraSetup = useSelector((state) => state.cameraSetupRedux.open);
    const openModalExportColumnsPdf = useSelector(state => state.fleetModalExportColumnsPdfRedux.open);
    const columnsToExportPFF = useSelector(state => state.fleetModalExportColumnsPdfRedux.columnsToExport);
    const openModalUpdateUnit = useSelector((state) => state.fleetModalUpdateUnitRedux.open);
    const loadingInitialCompletedVar = useSelector(state => state.catalogsRealtimeRedux.loadingInitialCompleted);
    const loadingStatingCatalog = useSelector(state => state.catalogsRealtimeRedux.loading);
    const openImportUnits = useSelector(state => state.unitsImport.openImport);
    const unitsImport = useSelector((state) => state.unitsImport);

    // Keep table in loading state while initial catalogs/realtime payloads are still syncing.
    const loadingInitialCompleted = Boolean(
        loadingInitialCompletedVar ||
        loadingStatingCatalog ||
        loadingUnitsList ||
        loadingReadings ||
        loadingVehicleStatus ||
        loadingLandmarkJson
    );

    //permissions
    const [selectedUnit, setSelectedUnit] = useState()
    const [openSidePanel, setOpenSidePanel] = useState(false);

    const [dataToMap, setDataToMap] = useState({});

    useEffect(() => {
        //Load initial Data
        dispatch(catalogLoad(['vehicleStatus', 'inputLabels']));
        dispatch(getKmls());
    }, [])

    const cleanFilterValues = {
        tags: [],
        events: [],
        time: null,
        moreFilters: []
    }

    useImportNotifications(
        state => state.unitsImport,
        setImportNotification
    );

    // Permissions
    const editablePermissions = HasPermission(user, "", [343])

    // Define initial order and columns to show to new users
    const initialDefaultColumns = [
        { "key": "maintenanceWarningEventsCount", "show": true },
        { "key": "label", "show": true },
        { "key": "unitTime", "show": true },
        { "key": "eventName", "show": true },
        { "key": "unitTags", "show": true },
        { "key": "driverName", "show": true },
        { "key": "vin", "show": true },
        { "key": "displayOdometer", "show": true },
        { "key": "engineHours", "show": true },
        { "key": "address", "show": false },
        { "key": "speed", "show": false },
        { "key": "speedLimit", "show": false },
        { "key": "make", "show": false },
        { "key": "model", "show": false },
        { "key": "year", "show": false },
        { "key": "esn", "show": false },
        { "key": "imei", "show": false },
        { "key": "linkedDevice", "show": false },
        { "key": "starterSupported", "show": false },
        { "key": "id", "show": false },
        { "key": "inspectionDeviceType", "show": false },
        { "key": "inspectionTagId", "show": false },
        { "key": "powerUnitNumber", "show": false },
        { "key": "maintenanceCompany", "show": false },
        { "key": "registrationCountry", "show": false },
        { "key": "registrationState", "show": false },
        { "key": "registrationExpiration", "show": false },
        { "key": "engineSerialNumber", "show": false },
        { "key": "chassisSerialNumber", "show": false },
        { "key": "licensePlate", "show": false },
        { "key": "assetType", "show": false },
        { "key": "assetSubtype", "show": false }
    ]

    //add the columns according to the permissions
    if (HasPermission(user, "defDrvr", [290])) {
        initialDefaultColumns.push({ "key": "driverDefault", "show": false });
    }

    const clearFilters = useCallback(() => {
        setHasFilters(false)
        dispatch(fleetMainChangeFilters(cleanFilterValues))
        changePreferences(cleanFilterValues)
    })

    const clearSelection = useCallback(() => {
        tableRef?.current?.setSelectedItems([]);
        setSelectedItems([]);
    }, []);

    const getSpeedFormat = (speed, unitType) => {
        // change the speed according to the unitType
        if (unitType) {
            speed = converSpeedToMph(speed, unitType)
        }
        if (speed && user.isKph) {
            speed = convertToKPH(speed)
        }
        return speed >= 0 ? (Math.round(speed)?.toLocaleString('en-US') + ' ' + (user.isKph ? "KPH" : "MPH")) : ''
    }

    // Direct memoized connection to RTK Slices O(1) Data Graph
    const computedData = useSelector(state => getData(state));

    // Phase 3.2: Throttled Rendering API
    // Limits the React DOM repaints to 700ms bursts to prevent browser freezing during WebSocket data storms
    // Internally manages the "ids" dependency so that it only re-renders if the explicitly observed IDs change
    const [data, changeIdsCallback] = useDataGridThrottlerWithTrackedIds(computedData, 700);

    const unitsEvents = useMemo(() => {
        const map = new Map();

        data.forEach(item => {
            if (!item.eventName) return;
            if (!map.has(item.eventName)) {
                map.set(item.eventName, {
                    id: item.eventCode,
                    value: item.eventName,
                    name: translateEvent(item.eventName, messages),
                });
            }
        });

        return Array.from(map.values());
    }, [data, messages]);

    const searchPlaceholder = useMemo(() => getSearchPlaceholder(columns, messages), [columns, messages]);


    const vehicleTimesOptions = [
        { id: "fleet_time_today_reported", name: messages["time_today_reported"] },
        { id: "fleet_time_today_not_reported", name: messages["time_today_not_reported"] },
        { id: "fleet_time_not_reported_seven_days", name: messages["time_not_reported_seven_days"] },
        { id: "fleet_time_not_reported_thirty_days", name: messages["time_not_reported_thirty_days"] }
    ];

    const fleetSections = [
        {
            name: messages['fleetView_unit'],
            id: "unit",
        },
        {
            name: messages['fleetView_group'],
            id: "group",
        }
    ];

    const changePreferences = useCallback((newValues) => {
        const oldPreferences = preferencesRef?.current?.getPreferences("User", "fleetMainView") || {}
        if (!_.isEqual(newValues, oldPreferences)) {
            const currentPreferences = { ...oldPreferences, ...newValues }
            preferencesRef.current.savePreference("User", "fleetMainView", currentPreferences)
        }
    })

    const getTempLabel = useCallback((item, temperatureValue) => {
        if (item?.unitVersionProduct === 'GV50MG')
            return ''
        return temperatureValue && `(${temperatureValue})`
    })

    const onChangeColumns = useCallback((newColums) => {
        let currentColumns = columns.filter(column => !column?.show);

        let mergedColumns = [...newColums, ...currentColumns];

        let cleanedColumns = [];
        mergedColumns?.forEach(newColum => {
            if (!cleanedColumns.find(cleanedColumn => cleanedColumn?.key === newColum?.key)) cleanedColumns.push(newColum);
        });
        setColumns(cleanedColumns);
        let prefColums = cleanedColumns.map(x => {
            return { key: x.key, show: x.show }
        })
        changePreferences({ columns: prefColums });
    });

    const onChangeSort = useCallback((newSort) => {
        changePreferences({ sort: newSort });
    });

    const onChangeRowsPerPage = useCallback((newPage, newRowsPerPage) => {
        changePreferences({ rowsPerPage: newRowsPerPage });
    });

    const dataFiltered = useMemo(() => {
        let listdata = [];
        data.forEach(item => {
            let additem = true;
            let tagInheritance = user.tagMode == "Inheritance"
            let realTags = filters?.tags
            if (tagInheritance) {
                realTags = tags.filter(t => {
                    return filters?.tags?.findIndex(ft => t?.tagPath?.includes(ft.id)) != -1
                });
            }

            if (realTags.length == 1 && realTags[0].id == -99 && (!filters.events || filters.events.length == 0) && !filters.time) {
                additem = true;
            } else {
                let validateUG = realTags && realTags.length > 0 && realTags[0].id != -99;
                let validateEV = filters.events && filters.events.length > 0;

                if (validateUG) {
                    let matches = [];
                    realTags.forEach(x => {
                        if (x.id === -1) {
                            if (item?.tags && item?.tags?.length) {
                                if (item?.tags?.find(t => t?.id == -1)) {
                                    matches.push(1);
                                } else {
                                    matches.push(0);
                                }
                            } else {
                                matches.push(1);
                            }
                        } else if (x.id === 0) {
                            matches.push(1);
                        } else {
                            if (item.tags && item?.tags?.length && item.tags.find(t => t.id === x.id)) {
                                matches.push(1);
                            } else {
                                matches.push(0);
                            }
                        }
                    });

                    if (!matches.includes(1)) {
                        additem = false;
                    }
                }

                //events
                if (validateEV && filters?.events?.findIndex(x => x?.value == item?.eventName) == -1) {
                    additem = false;
                }

                //unitTime
                const today = moment();

                if (filters.time) {
                    if (item.unitTime && !isNaN(item.unitTime)) {
                        let vehicleEventTime = null
                        if (moment(item.unitTime).isValid()) {
                            vehicleEventTime = moment(Number(item.unitTime))
                        } else {
                            if (moment.unix(item.unitTime.toString().substring(0, item.unitTime.length - 3)).isValid()) {
                                vehicleEventTime = moment.unix(Number(item.unitTime.toString().substring(0, item.unitTime.length - 3)))
                            }
                        }

                        if (vehicleEventTime) {
                            if (filters.time.id === "fleet_time_today_reported" && vehicleEventTime <= moment(moment().format('YYYY-MM-DD') + ' 00:00:00')) {
                                additem = false;
                            }
                            else if (filters.time.id === "fleet_time_today_not_reported" && vehicleEventTime > moment(moment().format('YYYY-MM-DD') + ' 00:00:00')) {
                                additem = false;
                            }
                            else if (filters.time.id === "fleet_time_not_reported_seven_days" && vehicleEventTime > moment(moment().format('YYYY-MM-DD') + ' 00:00:00').add("days", -7)) {
                                additem = false;
                            }
                            else if (filters.time.id === "fleet_time_not_reported_thirty_days" && vehicleEventTime > moment(moment().format('YYYY-MM-DD') + ' 00:00:00').add("days", -30)) {
                                additem = false;
                            }
                        }
                    } else if (item.unitTime === undefined) {
                        additem = false;
                    } else {
                        if (filters.time.id !== "fleet_time_today_reported") {
                            additem = false
                        }
                    }
                }
            }

            if (filters.moreFilters.length) {
                let issues = filters.moreFilters.some((item) => item?.id === "issues");
                let offlineDevices = filters.moreFilters.some((item) => item?.id === "offline-devices");
                let videoDevices = filters.moreFilters.some((item) => item?.id === "video-devices");

                let matchesIssues = issues && item.maintenanceWarningEventsCount;
                let matchesOfflineDevices = offlineDevices && item.isOffline;
                let matchesLinkedUnits = videoDevices && (item.videoDevices?.length > 0 && item.videoDevices[0]?.id !== item.id);

                if (!matchesIssues && !matchesOfflineDevices && !matchesLinkedUnits) {
                    additem = false;
                }
            }

            if (additem) listdata.push(item);
        });

        return listdata;
    }, [filters, data]);

    // onchange filters go to page 1
    useEffect(() => {
        tableRef?.current?.setPage(1);
        clearSelection();
    }, [filters, clearSelection])

    //Define the export filters to PDF when the collumns is mor than param number
    useEffect(() => {
        if (openModalExportColumnsPdf && columnsToExportPFF?.length && tableRef) {
            tableRef.current.exportPDF();
            dispatch(openModalExportColumnPdf({ open: false }));
        }
    }, [columnsToExportPFF]);

    useEffect(() => {
        const getLoadingText = () => messages?.loading ?? '';
        const shouldShowDataLoading = (item) => {
            if (!loadingInitialCompleted) return false;
            const hasAddress = Boolean(item?.address?.formatted || item?.address?.address);
            const hasVehicleInfo = Boolean(item?.vin || item?.ecuVin || item?.make || item?.model || item?.year);
            return !hasAddress || !hasVehicleInfo;
        };

        let defaultColumns = [
            {
                key: 'id',
                sort: true,
                show: false, // Hidden from UI
                title: 'ID',
                width: 100,
                export: true,
                exportOnly: true,
                //no render to avoid showing ID in UI but it will exist in export.
                exportValue: (item) => item.id,
                sortValue: (item) => item.id
            },
            {
                key: 'maintenanceWarningEventsCount',
                show: true,
                export: false,
                width: 20,
                sort: true,
                render: (item) => {
                    //Getting information from the SD Card
                    const sdCard = item?.sdCard ? checkDeviceData(item.sdCard) : null;
                    const sdCardStatus = sdCard?.status?.toUpperCase();
                    const isSdCardError = sdCardStatus && sdCardStatus !== "NORMAL";
                    //Getting warnings
                    const warnings = item?.maintenanceWarningEventsCount || 0
                    const { title, color } = getWarningCategory(isSdCardError, warnings, item?.isOffline, messages)

                    if (!title) return <></>

                    return (
                        <Tooltip title={title}>
                            <Icon
                                style={{
                                    marginLeft: 5,
                                    cursor: HasPermission(user, "wgrs", [278]) && "pointer",
                                    color: color
                                }}
                                className="toolbar-list-icon fs-20"
                                onClick={() => {
                                    if (HasPermission(user, "wgrs", [278])) {
                                        dispatch(openWarningsModal(item))
                                    }
                                }}
                            >
                                warning
                            </Icon>
                        </Tooltip>
                    );
                },
                sortValue: (item) => {
                    return item?.isOffline
                },
            },
            {
                key: 'label',
                sort: true,
                show: true,
                title: messages['fleetView_vehicle'],
                export: true,
                width: 250,
                render: (item) => {
                    const { icon, label } = item;
                    let truncate = label
                    if (label?.length > 30) {
                        truncate = (
                            <Tooltip
                                key={label}
                                title={label}
                            >
                                {label?.toString()?.slice(0, 30) + '...'}
                            </Tooltip>

                        )
                    }

                    return (
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            spacing={1}
                            wrap="nowrap"
                        >
                            <div>
                                <Tooltip
                                    key={item.label}
                                    title={messages['fleetView_unitOverViewPanel']}>
                                    <IconButton
                                        style={{ color: 'black' }}
                                        icon="gps_fixed"
                                        onClick={() => {
                                            dispatch(
                                                openOverViewUnit({
                                                    data: { unit: item },
                                                    open: true,
                                                }))
                                        }}
                                    />
                                </Tooltip>
                            </div>
                            <div>
                                <OemDataButton
                                    variant="icon"
                                    iconSize="medium"
                                    unitId={item.id}
                                    eventId={item.rowId}
                                    manufacturerName={item.manufacturerName}
                                    unitLabel={item.label}
                                />
                            </div>
                            <Grid item>
                                {
                                    icon
                                        ? <img src={`/assets/icons/${icon?.icon}`} alt="image" />
                                        : <NavigationIcon style={{ fontSize: "20px" }} />
                                }
                            </Grid>
                            <Grid item xs zeroMinWidth>
                                {editablePermissions &&
                                    <Typography
                                        noWrap
                                        className="btn-link-strong"
                                        onClick={() => {
                                            if (moduleUnitSettings) {
                                                if (HasPermission(user, "", [13])) {
                                                    setOpenSidePanel(false);
                                                    dispatch(openModalFleetUpdateUnit({ unitId: item.id }))
                                                }
                                            } else {
                                                if (HasPermission(user, "", [64])) {
                                                    setOpenSidePanel(false);
                                                    dispatch(openModalFleetUpdateUnit({ unitId: item.id }))
                                                    /* dispatch(unitEditUnitOpen(item.id)); */
                                                }
                                            }
                                        }}
                                    >
                                        {truncate}
                                    </Typography>
                                }
                                {!editablePermissions &&
                                    <Typography noWrap>
                                        {truncate}
                                    </Typography>
                                }
                            </Grid>
                        </Grid>
                    );
                },
                sortValue: (item) => {
                    const { label } = item;
                    return label?.replace("#", "").trim();
                }
            },
            // { key: 'engineHours', sort: true, show: true, title: messages['fleetView_engineHours'], width: 150, export: true },
            {
                key: 'engineHours',
                sort: true,
                show: true,
                title: messages['fleetView_engineHours'],
                width: 150,
                export: true,
                render: (item) => {
                    const engineHours = formatOffsetDisplayEngineHours(item)

                    return (
                        // <OdometerView {...item} isKph={user?.isKph}/>
                        <>
                            <span style={{ paddingRight: 8 }}>
                                {
                                    (item?.useEcuEngineHours) &&
                                    <span
                                        className="ecuChip"
                                        style={{ background: styles.ecu }}
                                    >
                                        ECU
                                    </span>
                                }
                                {getFormattedField(engineHours, 'H')}
                            </span>
                            <Button
                                type="icon"
                                icon="content_copy"
                                onClick={() => copyToClipboard(getFormattedField(engineHours, 'H'))}
                                fontSize="inherit"
                                className="btn-no-padding hover-item"
                            />
                        </>
                    )
                },
                exportValue: (item) => {
                    let engineHours = formatOffsetDisplayEngineHours(item)

                    if (item?.useEcuEngineHours && engineHours)
                        engineHours = `ECU ${getFormattedField(engineHours, 'H')}`
                    else
                        engineHours = getFormattedField(engineHours, 'H')

                    return engineHours

                },
                sortValue: (item) => {
                    const engineHours = formatOffsetDisplayEngineHours(item)
                    return parseFloat(engineHours)
                },
            },
            {
                key: 'unitTags',
                show: true,
                title: messages['fleetView_tags'],
                width: 100,
                export: true,
                render: (item) => {
                    let unitTags = [];
                    if (item?.tags && item?.tags?.length) {
                        unitTags = item?.tags?.map(t => {
                            return { ...t, color: getTagColor(t?.color) };
                        });
                    }

                    unitTags = unitTags?.filter(unitTag => unitTag?.id != -1);

                    return (
                        <div style={{ width: 100, maxWidth: 100 }}>
                            <TagsGroup
                                options={unitTags}
                                nameField="label"
                                colorField="color"
                            />
                        </div>
                    )
                },
                exportValue: (item) => {
                    return item.tags.map(x => x.label).join(',\r\n')
                }
            },
            {
                key: 'driverName',
                show: true,
                sort: true,
                title: messages['fleetView_drivers'],
                width: 200,
                export: true,
                render: (item) => {
                    let driverName = "";
                    if (item?.driverName) {
                        driverName = `${item?.driverName} ${item?.driverExternalId ? `(${item?.driverExternalId})` : ""}`;
                    }


                    return (
                        <span
                            style={{
                                fontWeight: 500
                            }}
                        >
                            {driverName}
                        </span>
                    );
                },
                exportValue: (item) => {
                    let driverName = "";
                    if (item?.driverName) {
                        driverName = `${item?.driverName} ${item?.driverExternalId ? `(${item?.driverExternalId})` : ""}`;
                    }

                    return driverName;
                },
                sortValue: (item) => {
                    let driverName = "";
                    if (item?.driverName) {
                        driverName = `${item?.driverName} ${item?.driverExternalId ? `(${item?.driverExternalId})` : ""}`;
                    }

                    return driverName;
                },
            },
            {
                key: 'address',
                show: true, //all users can be show the address and the point on map
                title: messages['fleetView_address'],
                width: 400,
                export: true,
                sort: true,
                render: (item) => {
                    const { address } = item;
                    let landmarkIcon = null;
                    //now usercode 3 should now include usercode 4
                    const enableEditViewLandmark = HasPermission(user, '', [3]);
                    if (address && item?.landmark) landmarkIcon = getIconLandmark(item?.landmark, tags);
                    if (!address && shouldShowDataLoading(item)) {
                        return <span className="subtitle">{getLoadingText()}</span>;
                    }
                    return (
                        <div>
                            {
                                address &&
                                <Fragment>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="flex-start"
                                    >
                                        <Grid item>
                                            <RoomIcon style={{ fontSize: 18, paddingRight: 10, paddingTop: 3 }} />
                                        </Grid>
                                        <Grid item xs zeroMinWidth>
                                            <Typography
                                                noWrap
                                                className="btn-link-strong"
                                                onClick={() => {
                                                    setSelectedUnit(item);
                                                    setOpenSidePanel(false);
                                                    setDataToMap({
                                                        show: true,
                                                        pointers: [{
                                                            id: item?.id,
                                                            latitude: parseFloat(item?.latitude || 0),
                                                            longitude: parseFloat(item?.longitude || 0),
                                                            direction: 35,
                                                            heading: item?.heading,
                                                            Label: item?.label,
                                                            eventName: item.eventName
                                                        }]
                                                    })
                                                }}
                                            >
                                                {address.formatted || `${address.address || ''}, ${address.zip || ''}, ${address.state || ''}`}
                                            </Typography>
                                        </Grid>
                                    </Grid>

                                    {
                                        enableEditViewLandmark
                                        &&
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="flex-start"
                                        >
                                            <Grid item>
                                                {
                                                    landmarkIcon ?
                                                        <img
                                                            style={{
                                                                width: 20,
                                                                height: 20,
                                                                paddingRight: 8,
                                                                paddingTop: 2
                                                            }}
                                                            src={landmarkIcon?.icon}
                                                            className="groupItem-icon"
                                                        /> :
                                                        <FlagIcon
                                                            style={{
                                                                fontSize: 18,
                                                                paddingRight: 10,
                                                                paddingTop: 3,
                                                                color: "#ddd"
                                                            }}
                                                        />
                                                }
                                            </Grid>
                                            <Grid item xs zeroMinWidth>
                                                <Typography
                                                    noWrap
                                                    className="btn-link-strong"
                                                    onClick={() => {
                                                        if (item?.landmark) {
                                                            dispatch(openFleetLandmarkModal(true, item, item?.landmark));
                                                        } else {
                                                            dispatch(openFleetLandmarkModal(true, item, null));
                                                        }
                                                    }}
                                                >
                                                    {item?.landmark
                                                        ? item?.landmark?.name
                                                        : messages['fleetView_create_landmark']}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    }
                                </Fragment>
                            }
                        </div>
                    )
                },
                exportValue: (item) => {
                    const { address } = item;
                    return address && (address.formatted || `${address.address || ''}, ${address.zip || ''}, ${address.state || ''}`) || '';
                },
                sortValue: (item) => {
                    const { address } = item;
                    try {
                        let showAddress = address?.formatted ? address.formatted : address?.address
                        if (showAddress)
                            return showAddress.trim()
                    } catch (e) { }

                    return address?.formatted
                }
            },
            {
                key: 'unitTime',
                sort: true,
                show: true,
                disableSearch: true,
                title: messages['fleetView_dataTime'],
                width: 200,
                export: true,
                render: (item) => {
                    let date = getDate(item.unitTime, item?.timeZone?.name);
                    return (
                        <div>
                            {
                                item?.unitTime && date.isValid() &&
                                <Fragment>
                                    <Timezone
                                        //oneControl
                                        onlyHour
                                        date={item?.unitTime}
                                        dateFormat={""}
                                        timeFormat={"h:mm a"}
                                        timezone={item?.timeZone?.name}
                                        className="fleetTimeZoneClassName"
                                        fromNow={true}
                                        locale={locale}
                                    />
                                    <div className='subtitle'>{moment(date).locale(locale).format('MMM DD, YYYY')}</div>
                                </Fragment>
                            }

                        </div>
                    )
                },
                exportValue: (item) => {
                    let datetimeZone = getAbbvTimezone(item?.timeZone?.name);

                    let formatDateInHours = getFormattedDateByTimeZone(item?.unitTime, item?.timeZone?.name, messages, "MMM DD, YYYY", true, lang);
                    if (formatDateInHours && datetimeZone)
                        formatDateInHours = `${formatDateInHours}, ${datetimeZone}`

                    return item?.unitTime && formatDateInHours || ''
                }
            },
            {
                key: 'eventName',
                sort: true,
                show: true,
                title: messages['fleetView_event'],
                width: 150,
                export: true,
                searchValue: (item) => getEventSearchValue(item, messages),
                render: (item) => {
                    return (
                        <div>
                            <span>
                                <EventReports element={{ event: item?.eventName || '' }} />
                                {GetEventName(item, true, false)}
                                <span>
                                    {' '}
                                    {GetEventTemperatureValue(item, user, false)}
                                </span>
                            </span>
                        </div>
                    );
                },
                exportValue: (item) => {
                    const raw = GetEventName(item) || item?.eventName || '';

                    const open = raw.indexOf('(');

                    const name = open >= 0 ? raw.slice(0, open).trim() : raw.trim(); 
                    const percent = open >= 0 ? raw.slice(open).trim() : "";     

                    const translated = translateEvent(name, messages);
                    const extraTemp = /temperature/i.test(raw)
                        ? ` ${GetEventTemperatureValue(item, user, false)}`
                        : '';

                    return `${translated} ${percent}${extraTemp}`.trim();
                },
                // Same color the Event cell shows on screen (P3-53848)
                exportColorValue: (item) => getEventColor(item?.eventName) ?? 'black',

            },

            {
                key: 'speed',
                sort: true,
                show: true,
                title: messages['fleetView_speed'],
                width: 150,
                export: true,
                render: (item) => {
                    return getSpeedFormat(item.speed, item.unitType)
                },
                exportValue: (item) => {
                    return getSpeedFormat(item.speed, item.unitType)
                },
                searchValue: (item) => getSpeedFormat(item.speed, item.unitType),
                sortValue: (item) => {
                    let speed = converSpeedToMph(item.speed, item.unitType)
                    speed = parseFloat(speed)
                    speed = isNaN(speed) ? -1 : speed
                    return parseFloat(speed)
                },
            },
            {
                key: 'speedLimit',
                sort: true,
                show: true,
                title: messages['fleetView_speedLimit'],
                width: 150,
                export: true,
                render: (item) => {
                    return getSpeedFormat(item.speedLimit)
                },
                exportValue: (item) => {
                    return getSpeedFormat(item.speedLimit)
                },
                searchValue: (item) => getSpeedFormat(item.speedLimit),
                sortValue: (item) => {
                    return parseFloat(item.speedLimit)
                },
            },
            { 
                key: 'vin', 
                sort: true, 
                show: true, 
                title: messages['fleetView_vin'], 
                width: 150, 
                export: true, 
                alphanumeric: true,
                searchValue: getVinSearchValue,
                exportValue: (item) => {
                    return item.useEcuVin ? item.ecuVin : item.vin || ''
                },
                render: (item) => {
                    const vinValue = item.useEcuVin ? item.ecuVin : item.vin;
                    if (!vinValue && shouldShowDataLoading(item)) {
                        return <span className="subtitle">{getLoadingText()}</span>;
                    }
                    return <span style={{ paddingRight: 8, whiteSpace: "nowrap" }}>
                        {
                            item.useEcuVin && item.ecuVin &&
                            <span
                                className="ecuChip"
                                style={{ background: styles.ecu }}
                            >
                                ECU
                            </span>
                        }
                        {vinValue || ''}
                    </span>
                },
            },
            {
                key: 'year',
                sort: true,
                show: true,
                title: messages['fleetView_year'],
                width: 50,
                export: true,
                alphanumeric: false,
                render: (item) => {
                    if (!item?.year && shouldShowDataLoading(item)) {
                        return <span className="subtitle">{getLoadingText()}</span>;
                    }
                    return item?.year || '';
                }
            },
            {
                key: 'make',
                sort: true,
                show: true,
                title: messages['fleetView_make'],
                width: 100,
                export: true,
                render: (item) => {
                    if (!item?.make && shouldShowDataLoading(item)) {
                        return <span className="subtitle">{getLoadingText()}</span>;
                    }
                    return item?.make || '';
                }
            },
            {
                key: 'model',
                sort: true,
                show: true,
                title: messages['fleetView_model'],
                width: 100,
                export: true,
                render: (item) => {
                    if (!item?.model && shouldShowDataLoading(item)) {
                        return <span className="subtitle">{getLoadingText()}</span>;
                    }
                    return item?.model || '';
                }
            },
            {
                key: 'displayOdometer',
                sort: true,
                show: true,
                title: messages['fleetView_engineOdometer'],
                width: 150,
                export: true,
                render: (item) => {
                    return (
                        <OdometerView {...item} isKph={user?.isKph} />
                    )
                },
                exportValue: (item) => {
                    const odoToExport = getOdometerValue(item, user?.isKph);
                    if (item.useEcuOdometer) {
                        return `ECU ${odoToExport}`;
                    } else {
                        return odoToExport;
                    }
                },
                sortValue: (item) => {
                    return getOdometerValue(item, user?.isKph, true);
                },
                searchValue: (item) => {
                    return getOdometerValue(item, user?.isKph);
                },
            },
            //{ key: 'engineHours', sort: true, show: true, title: messages['fleetView_engineHours'], width: 50, export: true },
            {
                key: 'esn',
                sort: true,
                show: true,
                title: messages['fleetView_usn'],
                width: 200,
                export: true,

                sortValue: (item) => {
                    return item.esn?.trim();
                }
            },
            { key: 'imei', sort: true, show: true, title: messages['fleetView_imei'], width: 200, export: true },
            {
                key: 'maintenanceCompany',
                sort: true,
                show: false, // Hidden from UI
                title: messages['fleetView_maintenance_company'],
                export: true,
                exportOnly: true,
                exportValue: (item) => {
                    return item.asset?.maintenanceCompany || '';
                },
            },
            {
                key: 'registrationCountry',
                sort: true,
                show: false, // Hidden from UI
                title: messages['fleetView_registration_country'],
                export: true,
                exportOnly: true,
                exportValue: (item) => {
                    return item.asset?.registrationCountry || '';
                },
            },
            {
                key: 'registrationState',
                sort: true,
                show: false, // Hidden from UI
                title: messages['fleetView_registration_state'],
                export: true,
                exportOnly: true,
                exportValue: (item) => {
                    return item.asset?.registrationState || '';
                },
            },
            {
                key: 'registrationExpiration',
                sort: true,
                show: false, // Hidden from UI
                title: messages['fleetView_registration_expiration_date'],
                export: true,
                exportOnly: true,
                exportValue: (item) => {
                    return item.asset?.registrationExpiration || '';
                },
            },
            {
                key: 'engineSerialNumber',
                sort: true,
                show: false, // Hidden from UI
                title: messages['fleetView_engine_serial_number'],
                export: true,
                exportOnly: true,
                exportValue: (item) => {
                    return item.asset?.engineSerialNumber || '';
                },
            },
            {
                key: 'chassisSerialNumber',
                sort: true,
                show: false, // Hidden from UI
                title: messages['fleetView_chassis_serial_number'],
                export: true,
                exportOnly: true,
                exportValue: (item) => {
                    return item.asset?.chassisSerialNumber || '';
                },
            },
            {
                key: 'licensePlate',
                sort: true,
                show: false, // Hidden from UI
                title: messages['fleetView_license_plate'],
                export: true,
                exportOnly: true,
                exportValue: (item) => {
                    return item.asset?.licensePlate || '';
                },
            },
            {
                key: 'assetType',
                sort: true,
                show: false, // Hidden from UI
                title: messages['fleetView_asset_type'],
                export: true,
                exportOnly: true,
                exportValue: (item) => {
                    return item.asset?.assetType || '';
                },
            },
            {
                key: 'assetSubtype',
                sort: true,
                show: false, // Hidden from UI
                title: messages['fleetView_asset_subtype'],
                export: true,
                exportOnly: true,
                exportValue: (item) => {
                    return item.asset?.assetSubtype || '';
                },
            },          

        ];

        if (HasPermission(user, "vidfleetvideo", [217])) {
            defaultColumns.push({
                key: 'videoDevices',
                alphanumeric: true,
                show: true,
                sort: true,
                title: messages['fleetView_linkedDevice'],
                width: 200,
                export: true,
                render: (item) => {
                    const videoDevices = item?.videoDevices || [];
                    const { id, esn, manufacturer } = videoDevices[0] || {};
                    if (!id || !esn || !manufacturer) return "";
                    return (
                        <div>
                            <span
                                style={{
                                    fontWeight: 500
                                }}
                            >
                                {esn}
                            </span>
                            <div className="subtitle">
                                {manufacturer}
                            </div>
                        </div>
                    )
                },
                exportValue: (item) => {
                    const videoDevices = item?.videoDevices || [];
                    const { id, esn, manufacturer } = videoDevices[0] || {};
                    return `${esn ?? ''} - ${manufacturer ?? ''}`;
                },
                searchValue: getLinkedDeviceSearchValue,
                sortValue: (item) => {
                    const videoDevices = item?.videoDevices || [];
                    const { esn } = videoDevices[0] || {};
                    return esn;
                }
            });
        }

        if (HasPermission(user, "starter_ed", [66])) {
            defaultColumns.push({
                key: 'starterSupported',
                show: true,
                title: messages['fleetView_starter'],
                width: 100,
                sort: true,
                export: true,
                render: (item) => {
                    let status = getStarterStatus(item);
                    let color = getStarterStatusColor(status);
                    let tooltip = getStarterStatusTooltip(status, messages);

                    const enableDisablePermission = HasPermission(user, "starter_ed", [66]);
                    const disabled = (!enableDisablePermission || status == 'NotSupport');
                    if (HasPermission(user, "starter_ed", [66])) return (
                        <Button
                            type="icon"
                            icon="vpn_key"
                            className={color}
                            disabled={disabled}
                            style={{ color }}
                            tooltip={!enableDisablePermission && messages['fleetView_starter_no_permission'] || tooltip}
                            onClick={(e) => {
                                e.preventDefault();

                                if (enableDisablePermission) {
                                    dispatch(modalEnableStarterOpen([{ ...item }]))
                                } else {
                                    NotificationManager.warning(
                                        messages['fleetView_starter_no_permission'],
                                        messages['wait'],
                                        3000,
                                        null,
                                        null,
                                        'warning',
                                        null
                                    );
                                }
                            }}
                        />
                    );
                },
                exportValue: (item) => {
                    let status = getStarterStatus(item);
                    return getStarterStatusTooltip(status, messages);
                },
                sortValue: (item) => {
                    let status = getStarterStatus(item);
                    return getStarterStatusTooltip(status, messages);
                }
            });
        }

        //if the user have permision for the driver default
        if (HasPermission(user, "defDrvr", [290])) {
            defaultColumns.push({
                key: 'driverDefault',
                show: true,
                sort: true,
                title: messages['fleetView_drivers_Default'],
                width: 200,
                export: true,
                render: (item) => {
                    let driverName = "";
                    if (item?.defaultDriverName) {
                        driverName = `${item?.defaultDriverName} ${item?.defaultDriverExternalId ? `(${item?.defaultDriverExternalId})` : ""}` || '';
                    }
                    return (
                        <span
                            style={{
                                fontWeight: 500
                            }}
                        >
                            {driverName}
                        </span>
                    );
                },
                exportValue: (item) => {
                    let driverName = "";
                    if (item?.defaultDriverName) {
                        driverName = `${item?.defaultDriverName} ${item?.defaultDriverExternalId ? `(${item?.defaultDriverExternalId})` : ""}` || '';
                    }
                    return driverName;
                },
                sortValue: (item) => {
                    let driverName = "";
                    if (item?.defaultDriverName) {
                        driverName = `${item?.defaultDriverName} ${item?.defaultDriverExternalId ? `(${item?.defaultDriverExternalId})` : ""}` || '';
                    }
                    return driverName;
                },
            });
            if (HasPermission(user, 'evir', [295])) {
                defaultColumns.push(
                    {
                    key: 'inspectionDeviceType',
                    sort: true,
                    show: false, // Hidden from UI
                    title: messages['fleetView_inspectionDeviceType'],
                    width: 100,
                    export: true,
                    exportOnly: true,
                    //no render to avoid showing ID in UI but it will exist in export.
                    exportValue: (item) => item?.asset?.inspectionDeviceType || null,
                    sortValue: (item) => item?.asset?.inspectionDeviceType || null
                    },
                    {
                    key: 'inspectionTagId',
                    sort: true,
                    show: false, // Hidden from UI
                    title: messages['fleetView_inspectionTagId'],
                    width: 100,
                    export: true,
                    exportOnly: true,
                    //no render to avoid showing ID in UI but it will exist in export.
                    exportValue: (item) => item?.asset?.inspectionTagId || null,
                    sortValue: (item) => item?.asset?.inspectionTagId || null
                    }
                );
            }
            if (HasPermission(user, 'zlogs', [294])) {
                defaultColumns.push({
                key: 'powerUnitNumber',
                sort: true,
                show: false, // Hidden from UI
                title: messages['fleetView_powerUnitNumber'],
                width: 100,
                export: true,
                exportOnly: true,
                //no render to avoid showing ID in UI but it will exist in export.
                exportValue: (item) => item?.asset?.powerUnitNumber || null,
                sortValue: (item) => item?.asset?.powerUnitNumber || null
                });
            }
        }

        let newColumns = sortColumnsCurrent({ columns: sortColumns }, defaultColumns);
        setColumns(newColumns);
    }, [locale, user?.isKph, loadingInitialCompleted]);


    let mainContextMenuOptions = [];
    if (HasPermission(user, "uout", [30])) {
        mainContextMenuOptions.push({ name: messages['fleetView_outputs'], disabled: !selectedItems?.filter(it => it.supportedOutputs > 0)?.length });
    }

    if (HasPermission(user, "grp_starter")) {
        mainContextMenuOptions.push({ name: messages['fleetView_ScheduledGroupStarter'], disabled: false });
    }

    if (HasPermission(user, "starter_ed", [66])) {
        mainContextMenuOptions.push({ name: messages['fleetView_enableDisableStarter'], disabled: !selectedItems?.filter(it => it.starterSupported && it.starterSupported != "false")?.length });
    }

    if (HasPermission(user, "locate", [33])) {
        mainContextMenuOptions.push({ name: messages['fleetView_locate'], disabled: !selectedItems?.length });
    }

    LogManagerConsole("Fleet-Data", dataFiltered)

    const sortColumnsCurrent = (preferences, columnsParameter) => {
        const { columns: preferencesColumns } = preferences;
        let newColumns = [];
        //Checks if each column from preferences exists in the actual table. We erased some columns, so this causes an error
        preferencesColumns.forEach((preferencesColumn) => {
            let result = columnsParameter.find((column) => column.key === preferencesColumn.key)
            if (result && !newColumns.find(newColumn => newColumn.key === preferencesColumn.key)) {
                newColumns.push({ ...result, ...preferencesColumn });
            }
        });

        //Then checks if there are columns that are not in preferences but are in the actual table. This avoid to miss new columns
        columnsParameter.forEach((column) => {
            let result = newColumns.find((c) => c.key === column.key)
            if (!result) {
                if (column?.key === "maintenanceWarningEventsCount") {
                    newColumns.unshift(column)
                } else {
                    newColumns.push(column);
                }
            }
        });
        return newColumns;
    }

    useEffect(() => {
        if (preferences?.columns && columns?.length) {
            if ((preferences.time?.id) || (preferences.tags && preferences.tags.length > 0) || (preferences.moreFilters && preferences.moreFilters.length > 0) || (preferences.events && preferences.events.length > 0)) {
                setHasFilters(true);
            } else {
                setHasFilters(false);
            }

            if (preferences?.isGrouping !== null) {
                setIsGrouping(preferences?.isGrouping)
            }

            dispatch(fleetMainChangeFilters({ ...cleanFilterValues, ...preferences }));

            if (preferences?.columns) {
                setSortColumns(preferences?.columns)
                let newColumns = sortColumnsCurrent(preferences, columns);
                if (newColumns?.length) setColumns(newColumns);
            } else {
                let initColumns = []

                initialDefaultColumns.forEach((initialDefaultColumn) => {
                    let result = columns.find((column) => column.key === initialDefaultColumn.key)
                    if (result && !initColumns.find(newColumn => newColumn.key === initialDefaultColumn.key)) {
                        initColumns.push({ ...result, ...initialDefaultColumn });
                    }
                })

                setColumns(initColumns)
            }

            if (preferences?.sort && preferences?.sort?.key) {
                setSort(preferences?.sort);
            }

            if (preferences?.rowsPerPage) {
                setRowsPerPage(preferences?.rowsPerPage);
            }
        }
    }, [preferences]);

    return (
        <div>
            <Preferences
                ref={preferencesRef}
                preferencesKey="fleetMainView"
                onInitialPreferences={(newPreferences) => {
                    setPreferences((prev) => {
                        //comparte object is the same update the state with the new preferences
                        if (JSON.stringify(prev) !== JSON.stringify(newPreferences)) {
                            return newPreferences;
                        }
                        return prev;
                    });
                }}
            >
                <Container maxWidth={false} className={!moduleUnitSettings ? 'container-view' : ''}>
                    <Paper elevation={0} style={{ padding: !moduleUnitSettings ? 24 : 0 }}>
                        {/* Toolbar */}
                        <Grid container direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item xs={6} sm={4}>
                                <Toolbar>
                                    <Grid style={{ display: 'flex' }}>
                                        <Button
                                            type="icon"
                                            tooltip={messages["table_filter"]}
                                            placement="bottom"
                                            icon="filter_list"
                                            onClick={() => { setOpenSidePanel(!openSidePanel) }}
                                            className={hasFilters ? 'select-view-icon-filter' : 'select-view-icon'}
                                        />
                                        {editablePermissions &&
                                            <Button
                                                type="icon"
                                                icon="settings"
                                                tooltip={messages['unit_settings_edit_multiple_units']}
                                                placement="bottom"
                                                onClick={() => { dispatch(editMultipleUnits(selectedItems)) }}
                                                disabled={!selectedItems.length}
                                                style={{ color: selectedItems.length == 0 ? "gray" : "black" }}
                                                className="select-view-icon"
                                            />
                                        }

                                        <TableButtons
                                            style={{ maxHeight: 500, overflowY: 'scroll' }}
                                            messages={messages}
                                            tableRef={tableRef}
                                            columns={columns?.length ? columns
                                                .filter(item => !item.exportOnly) //filter columns that are only for export
                                                .map((item) => ({
                                                    ...item,
                                                    title: item?.key === "maintenanceWarningEventsCount"
                                                        ? messages['fleetView_warnings']
                                                        : item?.title
                                                })) : []}
                                            onChangeColumns={(columns) => {
                                                let newColumns = columns?.length ? columns.map((item) => ({ ...item, title: item?.key === "maintenanceWarningEventsCount" ? "" : item?.title })) : []
                                                onChangeColumns(newColumns)
                                            }}
                                            onExport={(type) => {
                                                if (type === "Csv") {
                                                    tableRef.current.exportCSV();
                                                } else if (type === "Pdf") {
                                                    //if more than 7 columns, the pdf will be cut
                                                    const filterColumnsToExport = columns.filter(column => column?.show)
                                                    if (filterColumnsToExport?.length > 7) {
                                                        //show modal to select columns
                                                        dispatch(openModalExportColumnPdf({ open: true, columns: filterColumnsToExport }));
                                                    } else {
                                                        dispatch(openModalExportColumnPdf({ open: false, columns: [], refToExport: null }));
                                                        tableRef.current.exportPDF();
                                                    }
                                                }
                                            }}
                                        />

                                        {editablePermissions &&
                                            <Button
                                                type="icon"
                                                icon="ios_share"
                                                tooltip={messages['fleetView_importUnits']}
                                                placement="bottom"
                                                onClick={() => {
                                                    dispatch(openImportUnitsModal(true));
                                                }}
                                                className="select-view-icon"
                                            />
                                        }

                                        <MenuComponent
                                            disabled={loadingUnitsList || loadingReadings || loadingVehicleStatus || loadingLandmarkJson || loadingInitialCompleted}
                                            options={mainContextMenuOptions}
                                            icon={'more_vert'}
                                            className="context-menu-options"
                                            onClick={(option) => {
                                                let newItems = [];
                                                if (option?.name === messages['fleetView_outputs']) {
                                                    if (selectedItems?.length > 1) {
                                                        dispatch(fleetModalBulkOutputsOpen(true, selectedItems));
                                                    } else {
                                                        dispatch(fleetModalOutputsOpen(true, selectedItems[0].id));
                                                    }
                                                } else if (option?.name === messages['fleetView_enableDisableStarter']) {
                                                    newItems = selectedItems.filter(it => it.starterSupported && it.starterSupported != "false");
                                                    dispatch(modalEnableStarterOpen(newItems));
                                                    tableRef.current.setSelectedItems([]);
                                                    setSelectedItems([]);
                                                } else if (option?.name === messages['fleetView_locate']) {
                                                    dispatch(modalPingOpen(selectedItems.map(x => x.id), selectedItems));
                                                } else if (option?.name === messages['fleetView_ScheduledGroupStarter']) {
                                                    dispatch(fleetOpenModalStarterSchedule());
                                                } else if (option?.name === messages['fleetView_bulk_camera_config']) {
                                                    let cameras = selectedItems.map((item) => {
                                                        const videoDevices = item?.videoDevices || [];
                                                        const { label, manufacturer, id, esn } = videoDevices[0] || {};
                                                        return { deviceModel: manufacturer, unitId: id, unitLabel: label, esn }
                                                    });
                                                    dispatch(openModalCameraSetup({ open: true, units: cameras, bulk: true }))
                                                }
                                            }}
                                        />
                                    </Grid>
                                </Toolbar>
                            </Grid>

                            <Grid item xs={6} sm={4} style={{ textAlign: 'center' }}>
                                {fleetSections.map((filter, index) => {
                                    let outlined = true;
                                    if (filter.id === "group" && isGrouping) {
                                        outlined = false;
                                    } else if (filter.id === "unit" && !isGrouping) {
                                        outlined = false;
                                    }

                                    return (
                                        <Pill
                                            key={index}
                                            textField={'name'}
                                            item={filter}
                                            outlined={outlined}
                                            onClick={() => {
                                                if (filter.id === "group") {
                                                    setIsGrouping(true);
                                                    changePreferences({ isGrouping: true });
                                                    tableRef.current.setSelectedItems([]);
                                                    setSelectedItems([]);
                                                } else if (filter.id === "unit") {
                                                    setIsGrouping(false);
                                                    changePreferences({ isGrouping: false });
                                                    tableRef.current.setSelectedItems([]);
                                                    setSelectedItems([]);
                                                }
                                            }}
                                            style={{ width: 90, border: '0' }}
                                            label="pill-label-text"
                                            colorField="default"
                                            colorSelection="005bf8"
                                        />
                                    )
                                })}
                            </Grid>

                            <Grid item xs={12} sm={4} className="mb-10 text-right">
                                <Tooltip title={searchPlaceholder} placement="bottom" arrow>
                                    <SearchInput placeholder={searchPlaceholder} searchText={formatSearchText} onSearchText={(searchText) => {
                                        setFormatSearchText(searchText);
                                        let newSearchText = searchText?.replace("#", "");
                                        setSearchText(newSearchText);
                                        tableRef.current.setPage(1);
                                        tableRef.current.setSelectedItems([]);
                                        setSelectedItems([]);
                                    }} />
                                </Tooltip>
                            </Grid>
                        </Grid>
                        {
                            isGrouping ?
                                <ByVehicleGroups
                                    ref={tableRef}
                                    onSelectedItems={(selectedValues) => setSelectedItems(selectedValues)}
                                    searchText={searchText}
                                    loading={loadingInitialCompleted}
                                    columns={columns}
                                    data={dataFiltered}
                                    changeIdsCallback={changeIdsCallback}
                                    onChangeColumns={onChangeColumns}
                                    onChangeSort={onChangeSort}
                                    sort={sort}
                                    onChangeRowsPerPage={onChangeRowsPerPage}
                                    rowsPerPage={rowsPerPage}
                                    moduleUnitSettings={props.moduleUnitSettings}
                                    columnsToExportPFF={columnsToExportPFF}
                                /> :
                                <ByVehicles
                                    ref={tableRef}
                                    onSelectedItems={(selectedValues) => setSelectedItems(selectedValues)}
                                    searchText={searchText}
                                    loading={loadingInitialCompleted}
                                    columns={columns}
                                    data={dataFiltered}
                                    changeIdsCallback={changeIdsCallback}
                                    onChangeColumns={onChangeColumns}
                                    onChangeSort={onChangeSort}
                                    sort={sort}
                                    onChangeRowsPerPage={onChangeRowsPerPage}
                                    rowsPerPage={rowsPerPage}
                                    moduleUnitSettings={props.moduleUnitSettings}
                                    columnsToExportPFF={columnsToExportPFF}
                                />
                        }
                    </Paper>
                </Container>

                <SidePanel
                    style={{
                        zIndex: 2,
                        width: 400,
                        transform: 'translateX(400px)',
                        height: "calc(100% - 50px)"
                    }}
                    contentStyle={{
                        height: "calc(100% - 50px)"
                    }}
                    classSidePanel={hasFilters ? 'side-panel-icon-filter' : 'side-panel-icon'}
                    isOpen={openSidePanel}
                    toggle={() => setOpenSidePanel(!openSidePanel)}
                >
                    <SidePanelHeader>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="flex-start"
                        >
                            <Grid item>
                                <h2 style={{ margin: 0 }}>
                                    {messages['fleetView_advancedFilters']}
                                </h2>
                                <span
                                    className='btn-link'
                                    onClick={() => {
                                        clearFilters()
                                    }}
                                >
                                    {messages['fleetView_clearAll']}
                                </span>
                            </Grid>
                            <Grid item className="text-right">
                                <Button
                                    type="icon"
                                    icon="delete"
                                    tooltip={messages['fleetView_clearFilters']}
                                    placement="left"
                                    onClick={() => {
                                        clearFilters()
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </SidePanelHeader>

                    <SidePanelBody
                        style={{
                            height: "auto"
                        }}
                    >
                        {
                            openSidePanel &&
                            <div
                                style={{
                                    paddingLeft: 2,
                                    paddingRight: 2
                                }}
                            >
                                <TagsManage
                                    onlyTags={true}
                                    value={filters.tags || []}
                                    onChange={(items) => {
                                        dispatch(fleetMainChangeFilters({ ...filters, tags: items }));
                                        changePreferences({ tags: items });
                                        tableRef?.current?.setPage(1);
                                        tableRef?.current?.setSelectedItems([]);
                                    }}
                                    hideTagsWithoutEntities={true}
                                    mode="list"
                                    height={408}
                                />
                            </div>
                        }

                        <div style={{ paddingTop: 20 }}>
                            <Select
                                id="events"
                                value={filters.events}
                                onChange={(items) => {
                                    dispatch(fleetMainChangeFilters({ ...filters, events: items }))
                                    //save Preferences
                                    changePreferences({ events: items })
                                }}
                                options={unitsEvents.sort((a, b) => {
                                    if (a.name?.toString()?.toLowerCase() > b.name?.toString()?.toLowerCase()) return 1;
                                    if (b.name?.toString()?.toLowerCase() > a.name?.toString()?.toLowerCase()) return -1;
                                    return 0;
                                })}
                                onMenuOpen={() => {
                                    bottomRef?.current?.scrollIntoView();
                                }}
                                textField="name"
                                valueField="name"
                                label={messages['fleetView_events']}
                                placeholder={messages['fleetView_select']}
                                isClearable
                                selectedOptionsBelow
                                multiple
                            />
                        </div>

                        <div>
                            <Select
                                id="times"
                                value={filters.time}
                                onChange={(data) => {
                                    dispatch(fleetMainChangeFilters({ ...filters, time: data }))
                                    //save Preferences
                                    changePreferences({ time: data })
                                }}
                                onMenuOpen={() => {
                                    bottomRef?.current?.scrollIntoView();
                                }}
                                options={vehicleTimesOptions}
                                textField="name"
                                valueField="id"
                                label={messages['fleetView_times']}
                                placeholder={messages['fleetView_select']}
                                isClearable
                            />
                        </div>
                        <div style={{ marginTop: 20, paddingBottom: 150 }}>
                            <label className="input-normal-label">{messages['fleetView_bulk_more_filters']}</label>
                            <PillsGroup
                                options={[
                                    {
                                        id: "offline-devices",
                                        label: messages['fleetView_bulk_offline_devices'],
                                        color: "#EFA703",
                                    },
                                    {
                                        id: "video-devices",
                                        label: messages['fleetView_bulk_linked_units'],
                                        color: "#02ACFB",
                                    },
                                ]}
                                colorField="color"
                                multicolor
                                multiple
                                values={filters.moreFilters}
                                onChange={(items) => {
                                    dispatch(fleetMainChangeFilters({ ...filters, moreFilters: items }))
                                    changePreferences({ moreFilters: items })
                                }}
                            />
                        </div>
                        <div ref={bottomRef} />
                    </SidePanelBody>
                </SidePanel>

            </Preferences>

            <MapModal
                title={selectedUnit?.label}
                hiddenButton
                {...dataToMap}
                hiddenTraffic={true}
                hiddenWeather={true}
                hiddenSearchMap={true}
                hideModal={() => { setDataToMap({ show: false }) }}
                zoom={18}
            />

            <ModalPing />
            <ModalOutputs />
            <FleetModalBulkOutputs />
            <ModalScheduleStarter />

            <ModalEnableDisable />
            <ModalLandMark />
            {/* <EditUnit /> */}
            <EditUnitSettings />
            <EditMultipleUnits
                unitFiltered={dataFiltered}
                clearItemsSelected={() => {
                    tableRef.current.setSelectedItems([]);
                    setSelectedItems([]);
                }}
            />
            <ImportResultsModal />
            {openModalUpdateUnit && <ModalUpdateUnit />}
            {openImportUnits && <ModalImportUnits />}
            {openModalTroubleshootDevice && <ModalTroubleshootDevice />}
            {openModalWarnings && !moduleUnitSettings && <ModalWarnings />}
            {openMCameraSetup && !moduleUnitSettings && <CameraSetup />}
            {openModalExportColumnsPdf && <ModalExportColumnsPdf title={messages['fleet_export_modal_pdf_title']} detailMessage={messages['fleet_export_modal_pdf_message']} maxColumns={7} />}
        </div>
    )
}

export default Main;

/* UTILS */

const getDate = (dateIn, timezone) => {
    let date = moment(dateIn)
    if (!date.isValid()) {
        if (dateIn && dateIn.length > 10) {
            date = moment.unix(Number(dateIn?.substring(0, dateIn.length - 3)))
        } else {
            date = moment.unix(Number(dateIn))
        }
    }

    if (timezone) {
        date = date.tz(timezone);
    }

    return date;
}

const getStarterStatus = (vehicle) => {
    let resp = 'Disable';
    if (!vehicle.starterSupported || vehicle.starterSupported == "false") {
        return (resp = 'NotSupport');
    }

    if (vehicle.starterDisabled == "Enable") {
        resp = 'Enable';
    }

    return resp;
};

const parseMaintenanceCompanyName = (maintenanceCompanyString) => {
    if (!maintenanceCompanyString) return '';
    // Find "name=" and extract everything after it until "}" or end of string
    const nameMatch = maintenanceCompanyString.match(/name=([^}]+)/);
    return nameMatch ? nameMatch[1].trim() : '';
};

const getDateFormat = (registrationExpiration) => {
    //Since this field is meant for export only, we will default the format to MM/DD/YYYY for easier processing in import routines.
    
    if (!registrationExpiration) return '';
                    
    // Convert ISO date to MM/DD/YYYY format
    const date = new Date(registrationExpiration);
    if (isNaN(date.getTime())) return ''; // Invalid date check
                    
    const month = date.getMonth() + 1; // getMonth() returns 0-11
    const day = date.getDate();
    const year = date.getFullYear();
                    
    return `${month}/${day}/${year}`;
}

const getStarterStatusColor = (status) => {
    let color = 'colorNotSupported';
    switch (status) {
        case 'Enable':
            color = styles.color_button_green;
            break;
        case 'NotSupport':
            color = styles.color_gray_not_support;
            break;
        case 'Disable':
            color = styles.color_red_disabled;
            break;
        case 'Pending Enable':
            color = styles.blue;
            break;
        case 'Pending Disable':
            color = styles.color_pending_disabled;
            break;
        default:
            color = styles.color_gray_not_support;
    }
    return color;
};

const getStarterStatusTooltip = (status, messages) => {
    let tooltip = messages['fleetView_notSupport'];
    switch (status) {
        case 'Enable':
            tooltip = messages['fleetView_starter_enabled'];
            break;
        case 'NotSupport':
            tooltip = messages['fleetView_notSupport'];
            break;
        case 'Disable':
            tooltip = messages['fleetView_starterDisabled'];
            break;
        case 'Pending Enable':
            tooltip = messages['fleetView_starterEnablePending'];
            break;
        case 'Pending Disable':
            tooltip = messages['fleetView_starterDisablePending'];
            break;
        default:
            tooltip = messages['fleetView_notSupport'];
    }
    return tooltip;
};

/* DATA MEMORIZE FROM SOCKET */
const getJsonLandmark = (state) => state.catalogsRealtimeRedux.landmarks;
const getUnitsCatalog = createSelector([state => unitSelectors.selectAll(state)], getUnitsNaturalOrder);
const getReadingsCatalog = (state) => lastReadingSelectors.selectEntities(state);
const getVechicleStatus = (state) => state.catalogsRedux.vehicleStatus;
const getFilters = (state) => state.fleetMainRedux.filters;
// Pre-compute O(1) Dictionary for inputLabels
const getInputLabelsDict = createSelector(
    [(state) => state.catalogsRedux.inputLabels],
    (inputLabels) => (inputLabels || []).reduce((acc, curr) => {
        acc[curr.id] = curr;
        return acc;
    }, {})
);

// Use built-in entity dictionary mapping for O(1) access
const getDrivers = (state) => driverSelectors.selectEntities(state);

// Assets are connected via a Foreign Key `unitId`, so we map them to a dictionary once
const getAssetsByUnitId = createSelector(
    [state => assetSelectors.selectAll(state)],
    (assets) => assets.reduce((acc, curr) => {
        acc[curr.unitId] = curr;
        return acc;
    }, {})
);

// Phase 3.2: Row Reference Caching (O(1) Memory Recycling)
const rowCache = new RowMemoizer();

const getUnitResult = (unit, readings, vehicleStatus, landmarks, drivers, assetsByUnit, inputLabelsDict) => {
    if (unit.id == "-1") return;

    // O(1) constant time dictionary lookups instead of .find() iteration loops
    const unitLastReading = unit?.lastReading || {};
    const lastReading = readings[unit.id] || unitLastReading;
    let driver = unit.driverId ? drivers[unit.driverId] || {} : null;
    let driverDefault = unit.defaultDriverId ? drivers[unit.defaultDriverId] || {} : null;
    let asset = assetsByUnit[unit.id] || unit?.asset || {};

    // Cache lookup: If the exact same memory dependencies exist, recycle the object reference for React Memoization!
    return rowCache.memoize(
        unit.id,
        [
            unit,
            driver,
            asset,
            inputLabelsDict,
            unit?.offsetEngineOdometer,
            unit?.offsetEcuEngineOdometer,
            unit?.asset,
            lastReading?.engineOdometer,
            lastReading?.ecuEngineOdometer,
            lastReading?.address?.formatted,
            lastReading?.address?.address,
            lastReading?.address?.city,
            lastReading?.address?.state,
            lastReading?.address?.zip,
            lastReading?.latitude,
            lastReading?.longitude,
            lastReading?.heading,
            lastReading?.rowId,
            lastReading?.eventName,
            lastReading?.eventCode,
            lastReading?.unitTime,
            lastReading?.serverTime,
            lastReading?.vin,
            lastReading?.ecuVin,
            asset?.vin,
            asset?.ecuVin,
            asset?.make,
            asset?.model,
            asset?.year,
            asset?.assetType,
            asset?.assetSubtype,
        ],
        () => {
        // Missing dynamic calculations
        let landmarkId = lastReading?.landmarkId ? parseInt(lastReading?.landmarkId) : null;
        let vehicleStatusId = unit.vehicleStatusId || lastReading?.vehicleStatusId;

        const unitToPush = {
            ...unit,
            icon: vehicleStatus?.find(x => x.id == vehicleStatusId),
            make: asset?.make,
            model: asset?.model,
            year: asset?.year,
            vin: asset?.vin,
            heading: lastReading?.heading || unit.heading || 0,
            driverName: driver?.name || unit.driverName || '',
            driverExternalId: driver?.externalId || unit?.driverExternalId,
            defaultDriverId: unit?.defaultDriverId,
            defaultDriverName: driverDefault && driverDefault?.name,
            defaultDriverExternalId: driverDefault && driverDefault?.driverExternalId,
            address: lastReading?.address,
            unitTime: lastReading?.unitTime,
            unitType: lastReading?.unitType,
            eventCode: lastReading?.eventCode,
            eventName: lastReading?.eventName,
            rowId: lastReading?.rowId,
            speed: ((unit.useEcuSpeed && unit.ecuSpeed > 0) ? lastReading?.ecuSpeed : lastReading?.speed),
            speedLimit: lastReading?.speedLimit,
            starterSupported: unit?.starter,
            desiredStarterState: unit?.desiredStarterState,
            vehicleStatusId: vehicleStatusId,
            longitude: lastReading?.longitude,
            latitude: lastReading?.latitude,
            deviceId: lastReading?.deviceId,
            offsetEngineOdometer: unit.offsetEngineOdometer,
            engineOdometer: lastReading?.engineOdometer,
            useEcuOdometer: unit.useEcuOdometer,
            offsetEcuEngineOdometer: unit.offsetEcuEngineOdometer,
            ecuEngineOdometer: lastReading?.ecuEngineOdometer,
            engineHours: lastReading?.engineHours,
            ecuEngineHours: lastReading?.ecuEngineHours,
            ecuVin: asset?.ecuVin,
            deviceData: lastReading?.deviceData,
            landmarkname: lastReading?.landmarkname,
            temperatures: lastReading?.temperatures,
            landmark: landmarkId ? landmarks?.find(l => l?.id === landmarkId) : null,
            starterDisabled: unit?.desiredStarterState,
            startingLoad: lastReading?.startingLoad,
            temperatures: lastReading?.temperatures,
            inputs: (unit.inputs || []).map(inp => {
                const catalogLabel = inputLabelsDict[inp.labelId];
                return { ...inp, title: catalogLabel?.title || null };
            }),
            inspectionDeviceType: (asset?.inspectionDeviceType) ? asset?.inspectionDeviceType : null,
            inspectionTagId: (asset?.inspectionTagId) ? asset?.inspectionTagId : null,
            powerUnitNumber: (asset?.powerUnitNumber) ? asset?.powerUnitNumber : null,
            maintenanceCompany: (asset?.maintenanceCompany) ? parseMaintenanceCompanyName(asset.maintenanceCompany) : null,
            registrationCountry: (asset?.registrationCountry) ? asset?.registrationCountry : null,
            registrationState: (asset?.registrationState) ? asset?.registrationState : null,
            registrationExpiration: (asset?.registrationExpiration) ?  getDateFormat(asset.registrationExpiration) : null,
            engineSerialNumber: (asset?.engineSerialNumber) ? asset?.engineSerialNumber : null,
            licensePlate: (asset?.licensePlate) ? asset?.licensePlate : null,
            assetType: (asset?.assetType) ? asset?.assetType?.label : null,
            assetSubtype: (asset?.assetSubtype) ? asset?.assetSubtype?.name : null,
        }

        unitToPush.displayOdometer = formatOffsetDisplayOdometer(unitToPush)
        unitToPush.displayEngineHours = formatOffsetDisplayEngineHours(unitToPush)

        return unitToPush;
    });
}

const getData = createSelector(
    [getUnitsCatalog, getReadingsCatalog, getVechicleStatus, getFilters, getJsonLandmark, getDrivers, getAssetsByUnitId, getInputLabelsDict],
    (units, readings, vehicleStatus, filters, landmarks, drivers, assets, inputLabelsDict) => {
        let unitList = []
        try {
            units.forEach((unit) => {
                unitList.push(
                    getUnitResult(unit, readings, vehicleStatus, landmarks, drivers, assets, inputLabelsDict)
                );
            })
        } catch (error) {
            ExceptionManager(error, 'getData on fleet module');
        }

        return unitList;
    }
);
